// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-cart img[data-v-34bf98b5]{margin:auto}.update-address-message[data-v-34bf98b5]{font-size:1rem;font-weight:400;text-align:center;margin-top:12px;line-height:150%}#show-offer[data-v-34bf98b5]{margin-right:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
